module.exports = __webpack_public_path__ + "img/Exit.75eb3ba9.png";